import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4450d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProcessContainer" }
const _hoisted_2 = { class: "processTitle" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "进程信息", -1))
const _hoisted_4 = {
  key: 0,
  class: "container"
}
const _hoisted_5 = { class: "left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "进程列表", -1))
const _hoisted_7 = { class: "right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "选中进程的详细信息", -1))
const _hoisted_9 = {
  key: 0,
  class: "process-description"
}
const _hoisted_10 = { class: "process-collapse" }

import { useRoute } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import { processAPI } from '@/api/process';
import { ProcessState, Process, AntiVirus, BrowserProcess, ChatAppProcess, ProcessResponse } from '@/store/modules/process/types';
import { AntiVirusEnum } from '@/store/modules/process/antiVerusTable';
import { BrowserEnum } from '@/store/modules/process/browserTable';
import { ChatAppEnum } from '@/store/modules/process/chatAppTable';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "WifiWindow",
});

interface TimeLineNode {
    content: number,
    timeToDisplay: string,
    timestamp: string,
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const processState = ref({
    processes: [],
    isLoading: false,
} as ProcessState)
const tree = ref([] as Process[])

const defaultProps = {
    label: 'Name',
    children: 'children',
}
const processInfo = ref({} as Process)

const AntiVirusList = ref([] as AntiVirus[])
const BrowserList = ref([] as BrowserProcess[])
const ChatAppList = ref([] as ChatAppProcess[])

const popoverVisible = ref<boolean>(false)
const timeLineSlice = ref<TimeLineNode[]>([])
const nowTimeNode = ref<string>("")

const handleNodeClick = (data: Process) => {
    processInfo.value = data
}

const buildTree = (list: Process[]): Process[] => {
    const map: any = {};

    list.forEach(item => {
        if (!map[item.Pid]) {
            map[item.Pid] = item
        }
    });

    list.forEach(item => {
        if (item.Ppid != 0) {
            if (map[item.Ppid]) {
                if (map[item.Ppid]?.children) {
                    map[item.Ppid]?.children.push(item)
                } else {
                    map[item.Ppid].children = [item];
                }
            }
        }
    });

    return list.filter(item => {
        if (item.Ppid == 0 || !map[item.Ppid]) {
            return item;
        }
    })
}


const getAntiVirusTable = (list: Process[]): AntiVirus[] => {
    let res: AntiVirus[] = []
    let resMap = new Map()

    list.forEach(item => {
        if (AntiVirusEnum[`${item.Name}` as keyof typeof AntiVirusEnum]) {
            if (!resMap.get(item.Name)) {
                res.push({
                    processName: item.Name,
                    antiVirus: AntiVirusEnum[`${item.Name}` as keyof typeof AntiVirusEnum],
                })
                resMap.set(item.Name, true)
            }
        }
    });
    return res;
}
const getBrowserTable = (list: Process[]): BrowserProcess[] => {
    let res: BrowserProcess[] = []
    let resMap = new Map()
    list.forEach(item => {
        if (BrowserEnum[`${item.Name}` as keyof typeof BrowserEnum]) {
            if (!resMap.get(item.Name)) {
                res.push({
                    processName: item.Name,
                    browser: BrowserEnum[`${item.Name}` as keyof typeof BrowserEnum],
                })
                resMap.set(item.Name, true)
            }
        }
    });
    return res;
}

const getChatAppTable = (list: Process[]): ChatAppProcess[] => {
    let res: ChatAppProcess[] = []
    let resMap = new Map()
    list.forEach(item => {
        if (ChatAppEnum[`${item.Name}` as keyof typeof ChatAppEnum]) {
            if (!resMap.get(item.Name)) {
                res.push({
                    processName: item.Name,
                    chat: ChatAppEnum[`${item.Name}` as keyof typeof ChatAppEnum],
                })
                resMap.set(item.Name, true)
            }
        }
    });
    return res;
}

const getTimeLine = (data: ProcessResponse[]) => {
    for (let i = 0; i < data.length; i++) {
        timeLineSlice.value.push({
            content: data[i].id,
            timeToDisplay: getDisplayTime(data[i].created),
            timestamp: data[i].created
        })
    }
}
const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}

const handleChooseTime = async (data: string, id: number) => {
    popoverVisible.value = false
    processState.value.isLoading = true
    nowTimeNode.value = data

    try {
        const projId = projectId.value
        const uid = targetId.value;
        const response = await processAPI.getOneProcessInfoByUidAndTime(projId, uid, id);
        const arrayRes = JSON.parse(response[0].ProcessInfo)
        processState.value.processes = arrayRes
        tree.value = buildTree(arrayRes)
        processInfo.value = tree.value[0]

        AntiVirusList.value = getAntiVirusTable(arrayRes)
        BrowserList.value = getBrowserTable(arrayRes)
        ChatAppList.value = getChatAppTable(arrayRes)

    } catch (err) {
        processState.value.processes = [];
    } finally {
        processState.value.isLoading = false;
    }

}


onMounted(async () => {
    processState.value.isLoading = true
    try {
        const projId = projectId.value
        const uid = targetId.value;
        const response = await processAPI.getProcessListByUid(projId, uid);
        const arrayRes = JSON.parse(response[0].ProcessInfo)
        processState.value.processes = arrayRes
        tree.value = buildTree(arrayRes)
        processInfo.value = tree.value[0]

        AntiVirusList.value = getAntiVirusTable(arrayRes)
        BrowserList.value = getBrowserTable(arrayRes)
        ChatAppList.value = getChatAppTable(arrayRes)

        nowTimeNode.value = response[0].created
        getTimeLine(response)

    } catch (err) {
        console.log(err);
        processState.value.processes = []
    } finally {
        processState.value.isLoading = false
    }

})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        title: " ",
        width: 400,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"float":"right","margin-right":"50px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换时间")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_timeline, { class: "TimeLinePopover" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLineSlice.value, (timeNode, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: timeNode.timeToDisplay,
                  onClick: ($event: any) => (handleChooseTime(timeNode.timestamp, timeNode.content)),
                  type: timeNode.timestamp === nowTimeNode.value ? 'primary' : ''
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(timeNode.timeToDisplay) + " ", 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp", "onClick", "type"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_3
    ]),
    (processState.value.processes.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_el_tree, {
                  class: "el-tree-process",
                  data: tree.value,
                  props: defaultProps,
                  onNodeClick: handleNodeClick,
                  "highlight-current-row": "true"
                }, null, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            (JSON.stringify(processInfo.value) != '{}')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_el_descriptions, {
                    class: "el-descriptions-process",
                    direction: "horizontal",
                    column: 1,
                    border: "",
                    style: {"word-break":"break-all","word-wrap":"break-word"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, { label: "Pid" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(processInfo.value.Pid), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Name" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(processInfo.value.Name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "UserName" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(processInfo.value.UserName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "PathInfo" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(processInfo.value.PathInfo), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Ppid" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(processInfo.value.Ppid), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  "image-size": 200
                })),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_collapse, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse_item, {
                    title: "进程 — 杀软对照表",
                    name: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        data: AntiVirusList.value,
                        style: {"width":"100%"},
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            type: "index",
                            width: "50"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "processName",
                            label: "进程"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "antiVirus",
                            label: "杀软"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "进程 — 浏览器对照表",
                    name: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        data: BrowserList.value,
                        style: {"width":"100%"},
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            type: "index",
                            width: "50"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "processName",
                            label: "进程"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "browser",
                            label: "浏览器"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_collapse_item, {
                    title: "进程 — 聊天软件对照表",
                    name: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        data: ChatAppList.value,
                        style: {"width":"100%"},
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            type: "index",
                            width: "50"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "processName",
                            label: "进程"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "chat",
                            label: "聊天软件"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": 200
        }))
  ])), [
    [_directive_loading, processState.value.isLoading]
  ])
}
}

})